var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.083 19.15h-.001c-2.541-2.305-4.59-4.164-6.012-5.903C3.657 11.52 2.941 10.003 2.941 8.4v-.008A4.593 4.593 0 0 1 7.583 3.75h.002a5.12 5.12 0 0 1 3.85 1.788.75.75 0 0 0 1.14 0A5.12 5.12 0 0 1 16.42 3.75h.002a4.593 4.593 0 0 1 4.642 4.642V8.4c0 1.608-.716 3.125-2.13 4.854-1.422 1.74-3.47 3.6-6.01 5.91l-.001.001-.92.824z"
  })));
};
export default SvgHeartOutline;